import Vue from 'vue'
import Router from 'vue-router'
import store from '../state'
import Dashboard from '@/components/Dashboard'
import LoginPanel from '@/components/LoginPanel'
import DomainPanel from '@/components/DomainPanel'
import DomainDetailPanel from '@/components/DomainDetailPanel'
import DomainEditPanel from '@/components/DomainEditPanel'
import DomainResultsPanel from '@/components/DomainResultsPanel'
import DomainNotificationsPanel from '@/components/DomainNotificationsPanel'
import EmailPanel from '@/components/EmailPanel'
import EmailDetailPanel from '@/components/EmailDetailPanel'
import NotificationsPanel from '@/components/NotificationsPanel'
import BreachesPanel from '@/components/BreachesPanel'
import AuditPanel from '@/components/AuditPanel'
import AuditDetailPanel from '@/components/AuditDetailPanel'
import UserPanel from '@/components/UserPanel'
import APIKeysPanel from '@/components/APIKeysPanel'
import UsersPanel from '@/components/UsersPanel'
import SitesPanel from '@/components/SitesPanel'
import PasswordPanel from '@/components/PasswordPanel'

Vue.use(Router);

const router = new Router({
	//mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Dashboard,
			meta: {requiresAuth: true, redirectTo: 'domains'}
		},
		{
			path: '/login',
			name: 'login',
			component: LoginPanel,
			props: true
		},
		{
			path: '/logout',
			name: 'logout',
			component: Dashboard,
			meta: {showDialog: true, commit: {key: 'showModal', value: "logout"} }
		},
		{
			path: '/domains',
			name: 'domains',
			component: DomainPanel,
			meta: {requiresAuth: true}
		},
		{
			path: '/domain/:name',
			name: 'domainDetail',
			component: DomainDetailPanel,
			meta: {requiresAuth: true, redirectTo: 'domains'}
		},
		{
			path: '/domain/:name/edit',
			name: 'domainDetailEdit',
			component: DomainEditPanel,
			meta: {requiresAuth: true, redirectTo: 'domains'}
		},
		{
			path: '/domain/results/:name',
			name: 'domainResults',
			component: DomainResultsPanel,
			props: { pageSize: 12 },
			meta: {requiresAuth: true, redirectTo: 'domains'}
		},
		{
			path: '/domain/notifications/:name',
			name: 'domainNotificationResults',
			component: DomainNotificationsPanel,
			props: { pageSize: 12 },
			meta: {requiresAuth: true}
		},
		{
			path: '/domain/email/:name',
			name: 'domainEmailDetail',
			component: EmailDetailPanel,
			meta: {requiresAuth: true, redirectTo: 'domains'}
		},
		{
			path: '/domain/email/:name/edit',
			name: 'domainEmailDetailEdit',
			component: EmailDetailPanel,
			meta: {requiresAuth: true, redirectTo: 'domains'}
		},
		{
			path: '/email/:name',
			name: 'emailDetail',
			component: EmailDetailPanel,
			meta: {requiresAuth: true, redirectTo: 'emails'}
		},
		{
			path: '/emails',
			name: 'emails',
			component: EmailPanel,
			meta: {requiresAuth: true}
		},		
		{
			path: '/notifications',
			name: 'notifications',
			component: NotificationsPanel,
			props: { pageSize: 12 },
			meta: {requiresAuth: true}
		},
		{
			path: '/breaches',
			name: 'breaches',
			component: BreachesPanel,
			props: { pageSize: 12 },
			meta: {requiresAuth: true}
		},
		{
			path: '/audits',
			name: 'audits',
			component: AuditPanel,
			props: { pageSize: 12 },
			meta: {requiresAuth: true}
		},
		{
			path: '/audit/:rowkey',
			name: 'auditDetail',
			component: AuditDetailPanel,
			meta: {requiresAuth: true, redirectTo: 'audits'}
		},
		{
			path: '/password',
			name: 'password',
			component: PasswordPanel,
			meta: {requiresAuth: true}
		},
		{
			path: '/user',
			name: 'user',
			component: UserPanel,
			meta: {requiresAuth: true}
		},
		{
			path: '/settings/apikeys',
			name: 'apikeys',
			props: { pageSize: 10},
			component: APIKeysPanel,
			meta: {requiresAuth: true}
		},
		{
			path: '/settings/users',
			name: 'users',
			props: { pageSize: 12},
			component: UsersPanel,
			meta: {requiresAuth: true}
		},
		{
			path: '/settings/sites',
			name: 'sites',
			props: { pageSize: 12},
			component: SitesPanel,
			meta: {requiresAuth: true}
		}
	]
});

router.beforeEach((to, from, next) => {
 
	//Check authentication
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!store.state.authenticated) {

			//Keep the requested route
			store.commit('setRedirect', to);
			
			next('/login');
			return;
		}

		try {
			const now = new Date(),
				expires = new Date(store.state.jwt.expires);

			if (now > expires) {
			
				console.log('jwt expired:', expires);
				store.commit('logout');
			
				next({ name: 'login', params: { message: 'Your session has expired.' }});
				return;
			}
		}
		catch(err) {
			console.log('Exception checking jwt expiry date:', err);
		}
	}

	//Show a dialog instead of navigating
	if (to.matched.some(record => record.meta.showDialog)) {
		store.commit(to.meta.commit.key, to.meta.commit.value);

		next(false);
		return;
	}

	//Allow the route to continue
	next();
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js